module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('instamapsBreadcrumbs', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasBreadcrumbs),
      expression: "hasBreadcrumbs"
    }],
    attrs: {
      "title": _vm.$t('title')
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container addPadding"
  }, [_vm._m(0), _vm._v(" "), _c('section', [_c('h3', {
    staticClass: "form-signin-heading"
  }, [_vm._v("Quines galetes utilitzem?")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('Galetes de Google Analytics')))]), _vm._v(" "), _c('div', [_vm._v("\n\t\t\t\tEn tots els llocs i aplicacions web de l'ICGC utilitzem galetes de Google Analytics (per tant, de tercers). Aquestes galetes ens permeten accedir a informació relativa als continguts que més visiteu i com hi arribeu, o a les funcionalitats que més utilitzeu, fet que ens ajuda a optimitzar els serveis que us oferim. Les galetes usades tenen, en tot cas, caràcter temporal, amb l'única finalitat de fer més eficaç la navegació. En cap cas aquestes galetes proporcionen per si mateixes dades de caràcter personal.\n\t\t\t")]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _vm._m(2)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h4', {
    staticClass: "form-signin-heading",
    staticStyle: {
      "float": "right"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "href": "https://betaportal.icgc.cat/wordpress/faq-dinstamaps/#cookies",
      "target": "_blank"
    }
  }, [_vm._v("Vols accedir a Instamaps i no pots? Clica!")])]), _vm._v(" "), _c('h3', {
    staticClass: "form-signin-heading"
  }, [_vm._v("Per què utilitzem galetes?")]), _vm._v(" "), _c('div', [_vm._v("\n\t\t\t\tUtilitzem galetes per distingir-vos d'altres usuaris en els nostres webs, per millorar la informació i els serveis que us oferim, i per facilitar-vos l'accés:\n\t\t\t\t"), _c('ul', [_c('li', [_vm._v("Mesurem el nombre d'usuaris que utilitzen els serveis, per posar aquests serveis més a l'abast i per garantir-ne el rendiment.")]), _vm._v(" "), _c('li', [_vm._v("Analitzem dades anònimes per entendre com interactuen els usuaris amb els serveis i així poder optimitzar-los.")]), _vm._v(" "), _c('li', [_vm._v("Si així ho indiqueu, desem el vostre usuari i la vostra contrasenya per tal que no els hagueu d'introduir cada vegada que accediu a un determinat servei o aplicació web.")])]), _vm._v("Si desactiveu o rebutgeu les galetes, algunes parts d'Instamaps poden ser inaccessibles o no funcionar correctament (login usuari, creació de mapes, accés a la galeria privada).\n\t\t\t")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    staticClass: "default table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "border": "0",
      "cellpadding": "2",
      "cellspacing": "0",
      "width": "100%",
      "summary": ""
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticStyle: {
      "vertical-align": "top"
    },
    attrs: {
      "valign": "top",
      "width": "0"
    }
  }, [_c('p', [_vm._v("Galeta")])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "vertical-align": "top"
    },
    attrs: {
      "valign": "top",
      "width": "0"
    }
  }, [_c('p', [_vm._v("Finalitat")])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "vertical-align": "top"
    },
    attrs: {
      "valign": "top",
      "width": "0"
    }
  }, [_c('p', [_vm._v("Caducitat")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "vertical-align": "top"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', [_vm._v("_ga")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "vertical-align": "top"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', [_vm._v("Distingir usuaris.")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "vertical-align": "top"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', [_vm._v("2 anys")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "vertical-align": "top"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', [_vm._v("_gid")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "vertical-align": "top"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', [_vm._v("Distingir usuaris.")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "vertical-align": "top"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', [_vm._v("24 hores")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "vertical-align": "top"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', [_vm._v("_gat")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "vertical-align": "top"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', [_vm._v("Accelerar la ràtio de peticions.")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "vertical-align": "top"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', [_vm._v("1 minut")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "vertical-align": "top"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', [_vm._v("__utma")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "vertical-align": "top"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', [_vm._v("Distingir usuaris i sessions. La galeta es crea quan s’executa la llibreria javascript i no existeix prèviament. La galeta s’actualitza cada vegada que s’envien dades a Google Analytics.")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "vertical-align": "top"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', [_vm._v("2 anys")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "vertical-align": "top"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', [_vm._v("__utmb")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "vertical-align": "top"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', [_vm._v("Determinar noves sessions/visites. La galeta es crea quan s’executa la llibreria javascript i no existeix prèviament. La galeta s’actualitza cada vegada que s’envien dades a Google Analytics.")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "vertical-align": "top"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', [_vm._v("30 minuts")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "vertical-align": "top"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', [_vm._v("__utmc")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "vertical-align": "top"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', [_vm._v("Interoperar amb urchin.js (no s’utilitza a ga.js). Històricament, aquesta galeta operava conjuntament amb __utmb per determinar si un usuari estava en una nova sessió/visita.")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "vertical-align": "top"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', [_vm._v("Sessió")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "vertical-align": "top"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', [_vm._v("__utmt")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "vertical-align": "top"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', [_vm._v("Accelerar la ràtio de peticions.")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "vertical-align": "top"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', [_vm._v("10 minuts")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "vertical-align": "top"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', [_vm._v("__utmz")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "vertical-align": "top"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', [_vm._v("Emmagatzemar l’origen del tràfic. La galeta es crea quan s’executa la llibreria javascript i s’actualitza cada vegada que s’envien dades a Google Analytics.")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "vertical-align": "top"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', [_vm._v("6 mesos")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h3', {
    staticClass: "form-signin-heading"
  }, [_vm._v("Galetes pròpies")]), _vm._v(" "), _c('div', [_vm._v("\n\t\t\t\tA Instamaps també utilitzem galetes pròpies, totes elles de caràcter temporal. La principal finalitat d’aquestes galetes és facilitar-vos la navegació. En cap cas aquestes galetes proporcionen per si mateixes dades de caràcter personal.\n\t\t\t")]), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "default table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "border": "0",
      "cellpadding": "2",
      "cellspacing": "0",
      "width": "100%",
      "summary": ""
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticStyle: {
      "vertical-align": "top"
    },
    attrs: {
      "valign": "top",
      "width": "0"
    }
  }, [_c('p', [_vm._v("Galeta")])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "vertical-align": "top"
    },
    attrs: {
      "valign": "top",
      "width": "0"
    }
  }, [_c('p', [_vm._v("Finalitat")])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "vertical-align": "top"
    },
    attrs: {
      "valign": "top",
      "width": "0"
    }
  }, [_c('p', [_vm._v("Caducitat")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "vertical-align": "top"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', [_vm._v("cookieconsentICGC_status")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "vertical-align": "top"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', [_vm._v("Acceptació de galetes.")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "vertical-align": "top"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', [_vm._v("1 any")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "vertical-align": "top"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', [_vm._v("langCookie")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "vertical-align": "top"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', [_vm._v("Idioma.")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "vertical-align": "top"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', [_vm._v("1 any")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "vertical-align": "top"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', [_vm._v("perfil")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "vertical-align": "top"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', [_vm._v("Perfil d'Instamaps (Instamaps/Geolocal).")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "vertical-align": "top"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', [_vm._v("Sessió")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "vertical-align": "top"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', [_vm._v("tipusEntitat")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "vertical-align": "top"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', [_vm._v("Tipus d'entitat.")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "vertical-align": "top"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', [_vm._v("Sessió")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "vertical-align": "top"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', [_vm._v("token")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "vertical-align": "top"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', [_c('em', [_vm._v("Token")]), _vm._v(" d’autenticació.")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "vertical-align": "top"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', [_vm._v("Sessió")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "vertical-align": "top"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', [_vm._v("uid")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "vertical-align": "top"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', [_vm._v("Identificador de l’usuari autenticat.")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "vertical-align": "top"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', [_vm._v("Sessió")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "bottomPadding"
  }, [_vm._v("\n\t\t\t\tMés informació a la pàgina de "), _c('a', {
    attrs: {
      "href": "http://www.icgc.cat/L-ICGC/Sobre-l-ICGC/Politiques/Politica-de-proteccio-de-dades-personals/Politica-de-galetes-cookies",
      "target": "_blank"
    }
  }, [_vm._v("política de galetes de l'ICGC")]), _vm._v(".\n\t\t\t")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41ad0382"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/politica/politica.vue
// module id = 300
// module chunks = 0